import { endpoints } from '@/config';
import get from './get';

/**
 * @param {string} scope - expression
 * @param {string} view - ['list', 'timeline', 'map', 'raw', undefined]
 */
export default async function getKpiResult(accountId, kpiId, {
  scope,
  deviceId,
  pivotProperty,
  deviceTimezoneInput,
  period,
  offset,
  view,
  range,
} = {}) {
  const overrides = {
    method: 'GET',
    url: `${endpoints.kpi}/${kpiId}`,
  };

  return get(overrides, {
    accountId,
    scope,
    deviceId,
    pivotProperty,
    deviceTimezoneInput,
    period,
    offset,
    view,
    range,
  }, { kpiId });
}
